// extracted by mini-css-extract-plugin
export default {"input":"Form_input__hHLt-","button":"Form_button__uUXgt"};